module.exports = __webpack_public_path__ + "img/seting_cover2.eb0a279f.png";